import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import Table from 'react-bootstrap/Table';
import { toast } from "react-toastify";
import * as api from "../../../api_function";
import load from "../../../assets/Images/loader.gif";

const billingCycleOption = [
  // { label: "Yearly", value: "12" },
  { label: "Half-Yearly", value: "6" },
  // { label: "Quaterly", value: "3" },
];

const endUserPolicyOptionsSet = [
  { value: "1", label: "Standard: Upto 100 Mbps | Unlimited data | 3 devices" },
  // { value: "2", label: "Premium: Upto 200 Mbps | Unlimited data | 5 devices" }
];

const AddProductProWifi = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const [loading, setLoading] = useState(false);

  const [officeEmployeeCountOptions, setOfficeEmployeeCountOptions] = useState(false);
  const [coverageAreaRangeOptions, setCoverageAreaRangeOptions] = useState(false);
  const [accessPointsCountOptions, setAccessPointsCountOptions] = useState(false);
  const [planNameOptions, setPlanNameOptions] = useState(false);
  const [endUserPolicyOptions, setEndUserPolicyOptions] = useState(false);
  const [selectedPlanAndPricing, setSelectedPlanAndPricing] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(false);

  const [sdCharges, setSdCharges] = useState("");
  const [otcCharges, setOtcCharges] = useState("");
  const [monthlyCharges, setMonthlyCharges] = useState("");


  const [officeEmployeeCount, setOfficeEmployeeCount] = useState(false);
  const [coverageAreaRange, setCoverageAreaRange] = useState(false);
  const [accessPointsCount, setAccessPointsCount] = useState(false);
  const [planName, setPlanName] = useState(false);
  const [endUserPolicy, setEndUserPolicy] = useState(false);
  const [isSubmitDisable, setIsSubmitDisable] = useState(true);
  const [opportunityData, setOpportunityData] = useState()
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const OppId = searchParams.get("OppId");
  const navigate = useNavigate();

  const redirectOpportunity = () => {
    navigate(`/BusinessProWifiOpp?OppId=${OppId}`);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: "",
          OppId: OppId ? OppId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const responsedata = await response.json();
        const responseData = responsedata?.Response?.Data?.[0];
        // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

        // console.log("getLeads1" ,responsedata1);
        if (responsedata?.Status === "Success" && responseData) {
          // console.log("23456789",responseData.Status);

          setOpportunityData(responseData)
          // console.log(responseData.PgInfo.ProposalCounter);

          const pgInfo = responseData.PgInfo;

          // Plans and Pricing Dropdown values    
          try {
            const empCount = await api.getBBDIAEmpCount();

            const empCountOptionSet = empCount?.Response?.map(item => ({
              value: item.office_employee_count_id,
              label: item.office_employee_count
            }));

            // console.log("GetOpp empCountOptionSet: ", empCountOptionSet, pgInfo.EmployeeCount);
            setOfficeEmployeeCountOptions(empCountOptionSet)
            setOfficeEmployeeCount(empCountOptionSet.find(item => item.value === pgInfo.EmployeeCount) || null);
            // ================================================================== //
            const officeArea = await api.getBBDIAOffArea(pgInfo.EmployeeCount);

            const officeAreaOptionSet = officeArea?.Response?.map(item => ({
              value: item.coverage_area_range_id,
              label: item.coverage_area_range
            }));

            // console.log("getOpp officeAreaOptionSet: ", officeAreaOptionSet, pgInfo.OfficeArea);
            setCoverageAreaRange(officeAreaOptionSet.find(item => item.value === pgInfo.OfficeArea) || null)
            // ================================================================== //

            const apCount = await api.getBBDIA_AP({ empCount: pgInfo.EmployeeCount, OfficeArea: pgInfo.OfficeArea });

            const apCountOptionSet = apCount?.Response?.map(item => ({
              value: item.access_points_count,
              label: item.access_points_count
            }));

            // console.log("apCountOptionSet: ", apCountOptionSet);
            setAccessPointsCount(apCountOptionSet.find(item => item.value === pgInfo.NumberOfAccessPoints) || null)
            setAccessPointsCountOptions(apCountOptionSet)
            // ================================================================== //
            const getPlan = await api.getBBDIA_Plan({ empCount: pgInfo?.EmployeeCount, OfficeArea: pgInfo.OfficeArea, AP: pgInfo.NumberOfAccessPoints });
            // console.log("getPlan: ", getPlan);
            const getPlanOptionSet = getPlan?.Response?.map(item => ({
              value: item.plan_name_id,
              label: item.plan_name
            }));

            // console.log("getPlanOptionSet: ", getPlanOptionSet, responseData.ProductId);
            setPlanName(getPlanOptionSet.find(item => item.value === responseData.ProductId) || null)

            const getPlanPrice = await api.getBBDIAPlanPrice({ empCount: pgInfo.EmployeeCount, OfficeArea: pgInfo.OfficeArea, AP: pgInfo.NumberOfAccessPoints, planName: responseData.ProductId });
            // console.log("getPlanPrice: ", getPlanPrice);
            setSelectedPlanAndPricing(getPlanPrice?.Response)

            setSdCharges(getPlanPrice?.Response[0]?.sd);
            setOtcCharges(getPlanPrice?.Response[0]?.otc);
            setMonthlyCharges(getPlanPrice?.Response[0]?.monthly_price);
            setEndUserPolicy(endUserPolicyOptionsSet.filter((data) => data.value == pgInfo?.EndUserPolicy))

          } catch (err) {
            console.error(err);
          }

        }

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const plansAndPricing = async (selectedOption, name) => {
    if (!selectedOption || !name) return;
    // console.log(selectedOption, name);
    setIsSubmitDisable(true)

    if (name == 'EmployeeCount') {
      setOfficeEmployeeCount(selectedOption)
      setSelectedPlanAndPricing([])
      setCoverageAreaRange(false)
      setAccessPointsCount(false)
      setPlanName(false)
      setEndUserPolicy(false)

      setAccessPointsCountOptions(false)
      setPlanNameOptions(false)



      const officeArea = await api.getBBDIAOffArea(selectedOption.value);

      const officeAreaOptionSet = officeArea?.Response?.map(item => ({
        value: item.coverage_area_range_id,
        label: item.coverage_area_range
      }));

      // console.log("officeAreaOptionSet: ", officeAreaOptionSet);
      setCoverageAreaRangeOptions(officeAreaOptionSet)
      setSelectedPlan(false)
    }
    else if (name == 'OfficeArea') {
      setCoverageAreaRange(selectedOption)
      setSelectedPlanAndPricing([])
      setAccessPointsCount(false)
      setPlanName(false)
      setEndUserPolicy(false)

      setPlanNameOptions(false)
      const apCount = await api.getBBDIA_AP({ empCount: officeEmployeeCount.value, OfficeArea: selectedOption.value });

      const apCountOptionSet = apCount?.Response?.map(item => ({
        value: item.access_points_count,
        label: item.access_points_count
      }));

      // console.log("apCountOptionSet: ", apCountOptionSet);
      setAccessPointsCountOptions(apCountOptionSet)
      setSelectedPlan(false)
    }
    else if (name == 'NumberOfAccessPoints') {
      setAccessPointsCount(selectedOption)
      setSelectedPlanAndPricing([])
      setPlanName(false)
      setEndUserPolicy(false)

      const getPlan = await api.getBBDIA_Plan({ empCount: officeEmployeeCount.value, OfficeArea: coverageAreaRange.value, AP: selectedOption.value });
      // console.log("getPlan: ", getPlan);
      const getPlanOptionSet = getPlan?.Response?.map(item => ({
        value: item.plan_name_id,
        label: item.plan_name
      }));

      // console.log("getPlanOptionSet: ", getPlanOptionSet);
      setPlanNameOptions(getPlanOptionSet)
      setSelectedPlan(false)
    }
    else if (name == 'PlanName') {
      // console.log("selectedOption: ", selectedOption);
      setPlanName(selectedOption)
      setEndUserPolicy(false)
      const getPlanPrice = await api.getBBDIAPlanPrice({ empCount: officeEmployeeCount.value, OfficeArea: coverageAreaRange.value, AP: accessPointsCount.value, planName: selectedOption.value });
      // console.log("getPlanPrice: ", getPlanPrice, selectedOption.value);

      setSelectedPlanAndPricing(getPlanPrice?.Response)
      setSelectedPlan(getPlanPrice?.Response[0]?.plan_name_id)

      setSdCharges(getPlanPrice?.Response[0]?.sd);
      setOtcCharges(getPlanPrice?.Response[0]?.otc);
      setMonthlyCharges(getPlanPrice?.Response[0]?.monthly_price);

       setEndUserPolicy({ value: "1", label: "Standard: Upto 100 Mbps | Unlimited | 3 devices" })
       setIsSubmitDisable(false)
      // if (['1', '2', '7', '8', '13'].includes(selectedOption.value)) {
      // if (selectedOption.label.includes("Value")) {
      //   setEndUserPolicyOptions(endUserPolicyOptionsSet.filter((data) => data.value == '1'))
      // } else {
      //   setEndUserPolicyOptions(endUserPolicyOptionsSet)
      // }
    }
    else if (name == 'EndUserPolicy') {
      // setEndUserPolicy(endUserPolicyOptionsSet.filter((data) => data.value == selectedOption.value))
      setEndUserPolicy(selectedOption)
      setIsSubmitDisable(false)
    }

  };

  const addProduct = async () => {
    // alert("h")
    try {

      if (!selectedPlanAndPricing[0].plan_name_id) return;
      setLoading(true)

      const payload = {
        Oppid: OppId,
        productid: selectedPlanAndPricing[0].plan_name_id,
        EmployeeCount: selectedPlanAndPricing[0].office_employee_count_id,
        OfficeArea: selectedPlanAndPricing[0].coverage_area_range_id,
        NumberOfAccessPoints: selectedPlanAndPricing[0].access_points_count,
        EndUserPolicy: endUserPolicy?.value
      }
      const updateOppProductBBDIAResult = await api.createUpdateOppProductBBDIA(payload)
      // console.log("updateOppProductBBDIAResult: ", updateOppProductBBDIAResult?.Status);

      if (updateOppProductBBDIAResult?.Status == "Success") {
        toast.success("Proposal generated successfully!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }else if (updateOppProductBBDIAResult?.Status == "Failure") {
        toast.warning(updateOppProductBBDIAResult.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
      else {
        toast.warning("Failed to Generate Proposal!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false)

      setTimeout(() => {
        navigate(`/BusinessProWifiOpp?OppId=${OppId}`);
        // window.location.reload()
      }, 1500);

    }
  }



  let numericMonthlyCharges = Number(monthlyCharges?.replace(/,/g, ''));
  let quaterly = numericMonthlyCharges * 3;
  // console.log("quaterly:", quaterly.toLocaleString());

  // console.log("Type of monthlyCharges:", typeof monthlyCharges);

  //   let quaterly = Number(monthlyCharges) * 3
  //   console.log("monthlyCharges",monthlyCharges);

  //   console.log("quaterly",quaterly);


  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectOpportunity}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-2">Plan Selector</span>
        </div>
      </div>

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container shadow mb-3 bg-body rounded form-container" id="form3">
          <fieldset className="Company-details-form p-2">
            {/* Plans and Pricing Dependency Dropdowns */}

            {/* Office Employee Count Dropdown */}
            <div className="select-container mt-2">
              <label className="select-search-label">Employee Count*</label>
              <Select
                name="EmployeeCount "
                value={officeEmployeeCount}
                styles={style}
                onChange={(selectedOption) => plansAndPricing(selectedOption, 'EmployeeCount')}
                options={officeEmployeeCountOptions}
                className="basic-single form-control form-control-sm p-1"
                classNamePrefix="select"
                isSearchable={false}
                placeholder="Select employee count..."
                isDisabled={(opportunityData?.Status.toLowerCase() == "won" || opportunityData?.Status.toLowerCase() == "lost" || opportunityData?.PgInfo?.ProposalCounter >= 1)}
              />
            </div>

            <div className="select-container mt-2">
              <label className="select-search-label">Coverage Area Range*</label>
              <Select
                name="OfficeArea"
                value={coverageAreaRange}
                styles={style}
                onChange={(selectedOption) => plansAndPricing(selectedOption, 'OfficeArea')}
                options={coverageAreaRangeOptions}
                className="basic-single form-control form-control-sm p-1"
                classNamePrefix="select"
                isSearchable={false}
                placeholder="Select area range..."
                isDisabled={!coverageAreaRangeOptions}
              />
            </div>

            <div className="select-container mt-2">
              <label className="select-search-label">Number of Access Points*</label>
              <Select
                name="NumberOfAccessPoints "
                value={accessPointsCount}
                styles={style}
                onChange={(selectedOption) => plansAndPricing(selectedOption, 'NumberOfAccessPoints')}
                options={accessPointsCountOptions}
                className="basic-single form-control form-control-sm p-1"
                classNamePrefix="select"
                isSearchable={false}
                placeholder="Select access points..."
                isDisabled={!accessPointsCountOptions || (opportunityData?.Status.toLowerCase() == "won" || opportunityData?.Status.toLowerCase() == "lost")}
              />
            </div>

            <div className="select-container mt-2">
              <label className="select-search-label">Plan Name*</label>
              <Select
                name="PlanName "
                value={planName}
                styles={style}
                onChange={(selectedOption) => plansAndPricing(selectedOption, 'PlanName')}
                options={planNameOptions}
                className="basic-single form-control form-control-sm p-1"
                classNamePrefix="select"
                isSearchable={false}
                placeholder="Select plan..."
                isDisabled={planNameOptions ? false : true}
              />
            </div>

            <div className="select-container mt-2">
              <label className="select-search-label">End-User Policy*</label>
              <Select
                name="EndUserPolicy "
                value={endUserPolicy}
                styles={style}
                onChange={(selectedOption) => plansAndPricing(selectedOption, 'EndUserPolicy')}
                options={endUserPolicyOptions}
                className="basic-single form-control form-control-sm p-1"
                classNamePrefix="select"
                isSearchable={false}
                placeholder="Select end user policy..."
                isDisabled={!endUserPolicyOptions}
              />
            </div>

          </fieldset>

          {selectedPlanAndPricing?.length > 0 && endUserPolicy && (
            <div className="mt-5 p-1">
              <div className="table-responsive calculate-table">
                <Table striped bordered hover responsive className="table-sm text-center">
                  <thead className="">
                    <tr className="table-dark">
                      <th className="border border-black py-2">Broadband Plan Name</th>
                      {/* <th>Product ID</th> */}
                      {/* <th>Office Employee Count </th> */}
                      {/* <th>Coverage Area Range (Sq. Ft.)</th> */}
                      {/* <th>User License Count </th> */}
                      <th className="border border-black py-2">Speed</th>
                      <th className="border border-black py-2">Data Volume</th>
                      <th className="border border-black py-2">Speed Post FUP</th>
                      <th className="border border-black py-2">Wi-Fi Access Points</th>
                      {/* <th>Monthly Price</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {selectedPlanAndPricing?.map((item, index) => (
                      <tr key={index} className="">
                        <td className="border border-black py-2">{item.plan_name}</td>
                        {/* <td>{item.plan_name_id}</td>
                        <td>{item.office_employee_count}</td>
                        <td>{item.coverage_area_range_id}</td>
                        <td>{item.user_license_count}</td> */}
                        <td className="border border-black py-2">{item.broadband_speed}</td>
                        <td className="border border-black py-2">{item.data}</td>
                        <td className="border border-black py-2">{item.speed_post_fup}</td>
                        <td className="border border-black py-2">{item.access_points_count}</td>
                        {/* <td>{item.monthly_price}</td> */}
                      </tr>
                    ))}

                  </tbody>
                </Table>
              </div>



              <div className="table-responsive calculate-table">
                <Table striped bordered hover responsive className="table-sm ">
                  <thead className="">
                    <tr className="table-dark">
                      <th className="border border-black py-2" colSpan="3">Charge Type</th>
                      <th className="border border-black  py-2" colSpan="3">Amount</th>
                    </tr>

                  </thead>

                  <tbody>
                    <tr>
                      <th className="border border-black  py-2 " colSpan="3">One Time Charges (OTC)</th>
                      <td className="border border-black py-2" colSpan="3">Rs. {otcCharges}</td>
                    </tr>
                    <tr>
                      <th className="border border-black py-2" colSpan="3">Security Deposit (SD)</th>
                      <td className="border border-black py-2" colSpan="3">Rs. {sdCharges}</td>
                    </tr>
                    <tr>
                      <th className="border border-black py-2" colSpan="3">Monthly Recurring Charges</th>
                      <td className="border border-black py-2" colSpan="3">Rs. {monthlyCharges}</td>
                    </tr>
                    <tr>
                      <th className="border border-black py-2" colSpan="3">Quaterly Recurring Charges</th>
                      <td className="border border-black py-2" colSpan="3">Rs.  {monthlyCharges ? quaterly.toLocaleString() : ""}</td>
                    </tr>
                    <tr>
                      <th className="border border-black py-2" colSpan="3">Billing Frequency</th>
                      <td className="border border-black py-2" colSpan="3">Quarterly (Advance)</td>
                    </tr>

                  </tbody>
                </Table>
              </div>
            </div>

          )}

          <div className=" text-center p-3">
            <button
              type="button"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={addProduct}
              disabled={isSubmitDisable || (opportunityData?.Status.toLowerCase() == "won" || opportunityData?.Status.toLowerCase() == "lost")}
            >
              Generate Proposal
            </button>
          </div>

        </div>
      )}
    </>
  );
};

export default AddProductProWifi;